import { JobsActionTypes } from './constants';

type JobsAction = { type: string, payload?: {} | string };

export const getJobs = (query): JobsAction => ({
    type: JobsActionTypes.GET_JOBS,
    payload: { query },
});

export const jobsApiResponseSuccess = (actionType: string, data: any): JobsAction => ({
    type: JobsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const jobsApiResponseError = (actionType: string, error: string): JobsAction => ({
    type: JobsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const startJobsStream = (): JobsAction => ({
    type: JobsActionTypes.START_JOBS_STREAM,
});

export const stopJobsStream = (): JobsAction => ({
    type: JobsActionTypes.STOP_JOBS_STREAM,
});

export const upsertJobFromStream = (job): JobsAction => ({
    type: JobsActionTypes.JOB_STREAM_UPDATE,
    payload: { job },
});

export const deleteJobFromStream = (jobId: string): JobsAction => ({
    type: JobsActionTypes.JOB_STREAM_DELETE,
    payload: { jobId },
});

export const jobsStreamConnected = (): JobsAction => ({
    type: JobsActionTypes.JOB_STREAM_CONNECTED,
});

export const jobsStreamDisconnected = (): JobsAction => ({
    type: JobsActionTypes.JOB_STREAM_DISCONNECTED,
});

export const jobsStreamError = (error: string): JobsAction => ({
    type: JobsActionTypes.JOB_STREAM_ERROR,
    payload: { error },
});
